import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Company } from 'src/app/models/company.model';
import { SignatureRequest } from 'src/app/models/signature-request.model';
import { ApiService } from 'src/app/services/api.service';
import { INVALIDATED_LINK_MESSAGE } from 'src/app/constants/api-messages';

@Component({
  selector: 'app-accept-conditions-dialog',
  templateUrl: './accept-conditions-dialog.component.html',
  styleUrls: ['./accept-conditions-dialog.component.sass']
})
export class AcceptConditionsDialogComponent implements OnInit {

  private signature_request:SignatureRequest;
  public company:Company = null as any;
  private signatory_uuid:string;
  public loading:boolean = false;

  constructor(public dialogRef: MatDialogRef<AcceptConditionsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { signature_request:SignatureRequest, signatory_uuid:string },
              private api:ApiService,
              private router:Router) {

    this.signature_request = data.signature_request;
    this.company = this.signature_request.requester.company as Company;
    this.signatory_uuid = data.signatory_uuid;
  }

  ngOnInit(): void {
    this.fetchLegalDocument();
  }

  accept() {
    this.loading = true;
    this.api.acceptSignatory(this.signature_request.uuid, this.signatory_uuid).subscribe(
      data => {
        this.loading = false;
        this.dialogRef.close({success: true});
      },
      error => {
        this.loading = false;
        // El emisor pudo invalidar el link mientras la página estaba abierta.
        if(error.error?.message === INVALIDATED_LINK_MESSAGE) {
          this.dialogRef.close();
          this.router.navigate(['/signatures', 'invalidated']);
        }
      }
    );
  }

  private fetchLegalDocument() {

  }
}
